import FeatureShowcase from './FeatureShowcase';
export type { FeatureItem, FeatureShowcaseProps } from './FeatureShowcase';
export default FeatureShowcase;